import { render, staticRenderFns } from "./guangzQuery.vue?vue&type=template&id=d5aaa19c"
import script from "./guangzQuery.vue?vue&type=script&lang=js"
export * from "./guangzQuery.vue?vue&type=script&lang=js"
import style0 from "./guangzQuery.vue?vue&type=style&index=0&id=d5aaa19c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports